const Testimonial = ({ testimonial, color }) => {
  return <div className="mb-4">
    <q className="leading-relaxed text-black text-left block mb-4">{testimonial.quote}</q>
    <div className="flex items-center justify-start pb-4">
      <div className="rounded-full mr-2 align-top overflow-hidden w-16 h-16 block">
        <img className="object-cover w-full h-full block" src={testimonial.img} alt={testimonial.personName} />
      </div>
      <div>
        <span className={'font-bold block text-' + color}>{testimonial.personName}</span>
        <em className="block text-sm text-gray-700">{testimonial.personTitle}</em>
      </div>
    </div>
  </div>
}

export default Testimonial
